import { useEffect } from "react";
import Modal from "../modal";
import KaspiStatus from "../kaspiStatus";
import useKaspiPayment from "../../hooks/useKaspiPayment";
import c from "./styles.module.scss";

const FINAL_STATUSES = ["Processed", "Error", "Cancelled", "Expired", "Timeout"];

const KaspiModal = ({ orderNumber, show, onClose, onSuccess }) => {
  const { status, amount, startPayment, reset } = useKaspiPayment({
    orderNumber,
    autoRedirect: true,
    onSuccess,
  });

  const handleClose = () => {
    reset();
    onClose();
  };

  useEffect(() => {
    if (show && !status) {
      startPayment();
    }
  }, [show, startPayment, status]);

  useEffect(() => {
    if (!status || !FINAL_STATUSES.includes(status)) {
      return undefined;
    }

    const timeout = setTimeout(() => {
      handleClose();
    }, 2000);

    return () => clearTimeout(timeout);
  }, [status]);

  return (
    <Modal show={show} onClose={handleClose} closable={false}>
      <div className={c.inner}>
        <div className={c.title}>Оплата с Kaspi.kz</div>
        <div className={c.kaspiStatus}>
          <KaspiStatus status={status} amount={amount} />
        </div>
      </div>
    </Modal>
  );
};

export default KaspiModal;
